/*
  Copyright Epic Games, Inc. All Rights Reserved.
*/

import { CruxSectionFragment } from "@cosmos/hygraph-schema";
import { BackgroundContainer, ResponsiveContainer, SectionContainer, SectionHeading } from "@components/elements";
import { extractBackgroundContainerProps, extractSectionContainerProps } from "@components/utils/section.utils";
import { VStack } from "@panda/jsx";
import { CruxLinks } from "./CruxLinks.molecule";

export const CruxSection = ({ config, cruxLinks }: CruxSectionFragment): React.JSX.Element | null => {
	const validHeading = Boolean(config?.heading?.title || config?.heading?.desc);
	const contentfulLinks = cruxLinks?.filter((cruxLink) => !!cruxLink.label);
	const slicedLinks = contentfulLinks?.slice(0, 4);
	const validContent = Boolean(slicedLinks?.length);
	if (!validHeading && !validContent) return null;
	return (
		<BackgroundContainer {...extractBackgroundContainerProps(config)}>
			<ResponsiveContainer>
				<SectionContainer {...extractSectionContainerProps(config)}>
					<VStack
						alignItems="stretch"
						gap={{ sm: "eds.dimension.48", smDown: "eds.dimension.40" }}
						className="crux-section"
					>
						{validHeading ? <SectionHeading {...config?.heading} /> : null}
						{validContent ? <CruxLinks links={slicedLinks} /> : null}
					</VStack>
				</SectionContainer>
			</ResponsiveContainer>
		</BackgroundContainer>
	);
};
